// components/Accordion.styled.ts

import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";
import { Span } from "utils/styling/typography.styled";

export const AccordionSection = styled.div`
    margin-bottom: 1rem;
`;

export const AccordionTitle = styled.div`
    cursor: pointer;
    color: grey;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    background-color: ${colourScheme.primary}; // Adjust to match your theme
    border-radius: 0.25rem;
`;

export const AccordionIcon = styled.span`
    margin-left: auto;
`;

export const AccordionContent = styled.div`
    padding: 0.5rem;
    background-color: ${colourScheme.primaryDark}; // Adjust to match your theme
    border-radius: 0.25rem;
    animation: fadeIn 0.3s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
            max-height: 0;
        }
        to {
            opacity: 1;
            max-height: 100vh;
        }
    }
`;

export const AccordionSpan = styled(Span)`
    color: ${colourScheme.grey};
`;
